import { signOut } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import firebaseConfig from '../../config';

const { databaseId } = firebaseConfig;

function UserProfileFactory(firebase) {
  const checkIfUserCanLogInDirectly = async ({ email }) => {
    const checkIfUserCanLogInDirectlyCallable = httpsCallable(
      firebase.functions,
      'user-account-checkIfUserCanLogInDirectly'
    );
    return checkIfUserCanLogInDirectlyCallable({ email, databaseId });
  };

  const uploadAvatar = async (avatarFile) => {
    const uploadAvatarCallable = httpsCallable(
      firebase.functions,
      'user-avatar-upload'
    );
    return uploadAvatarCallable({ avatarFile, databaseId });
  };

  const logout = async () => signOut(firebase.auth);

  // Firestore rules allow users to update only this field on their own doc
  // (updateOnlyTheseAllowedFields(['preferredLanguage'])).
  const setPreferredLanguage = async ({ uid, language }) =>
    updateDoc(doc(firebase.fsdb, 'users', uid), {
      preferredLanguage: language
    });

  return {
    checkIfUserCanLogInDirectly,
    uploadAvatar,
    logout,
    setPreferredLanguage
  };
}

export default UserProfileFactory;
